import type {
  ExternalProviderRepository,
  ExternalProviderDashboardVM,
  SubmitEvaluationBody,
  SubmitInvoiceBody,
  SubmitRequestDataBody,
  InitializeContractBody,
} from "@shared-kernel/application/ports/external-provider/external-provider-repository";
import { TokenBasedHttpGateway } from "@shared-kernel/secondary/token-based-http-gateway";
import backendConfig from "@config/backend";

export class BackendExternalProviderRepository extends TokenBasedHttpGateway implements ExternalProviderRepository {
  private _route: string = "v1/external-provider";

  constructor(accessToken: string) {
    super(backendConfig.url, accessToken);
  }

  async getDashboard(): Promise<ExternalProviderDashboardVM> {
    const response = await this._instance.get<ExternalProviderDashboardVM>(`${this._route}/dashboard`);
    return response.data;
  }

  async submitEvaluation(participationId: string, body: SubmitEvaluationBody): Promise<void> {
    await this._instance.post(`${this._route}/participations/${participationId}:evaluate`, body);
  }

  async uploadInvoice(file: File): Promise<string> {
    const formData = new FormData();
    formData.append("invoice", file);
    const response = await this._instance.post<string>(`${this._route}/participations/invoices`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  }

  async submitInvoice(participationId: string, body: SubmitInvoiceBody): Promise<void> {
    await this._instance.post(`${this._route}/participations/${participationId}:submit-invoice`, body);
  }

  async uploadSpeakerResume(file: File): Promise<string> {
    const formData = new FormData();
    formData.append("speakerResume", file);
    const response = await this._instance.post<string>(`${this._route}/requests/speaker-resumes`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  }

  async submitRequestData(requestId: string, body: SubmitRequestDataBody): Promise<void> {
    await this._instance.post(`${this._route}/requests/${requestId}:complete`, body);
  }

  async initializeContract(body: InitializeContractBody): Promise<string> {
    const response = await this._instance.post<string>(`${this._route}/requests/contract:initialize`, body);
    return response.data;
  }
}
